import { LOAD_LABELS } from "./type";

const initialState = {
  loadedData: null,
};

const loadLabelReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_LABELS:
      return {
        ...state,
        loadedData: action.payload,
      };
    default:
      return state;
  }
};

export default loadLabelReducer;
